import { formatDuration } from '@core/shared/utils';
import * as i0 from "@angular/core";
export let DurationPipe = /*#__PURE__*/(() => {
  class DurationPipe {
    transform(value, format = 'mm:ss') {
      return formatDuration(value, format);
    }
    static {
      this.ɵfac = function DurationPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DurationPipe)();
      };
    }
    static {
      this.ɵpipe = /*@__PURE__*/i0.ɵɵdefinePipe({
        name: "duration",
        type: DurationPipe,
        pure: true
      });
    }
  }
  return DurationPipe;
})();